interface DialogTemplateOptions {
	id: string
	cancelText: string
	confirmText: string
	content: string
	title?: string
}

export function dialogTemplate({
	id,
	cancelText,
	confirmText,
	content,
	title,
}: DialogTemplateOptions): string {
	return `
        <dialog id="${id}" tabindex="-1">
            <form method="dialog">
                <span class="dialog-focus-sentinel" tabindex="0" autofocus></span>
                ${title ? `<h2 class="dialog-title">${title}</h2>` : ''}
                <div class="dialog-content">
                    ${content}
                </div>
                <menu class="dialog-menu">
                    <button
                        type="reset"
                        id="dialog-cancel-btn"
                        class="secondary"
                    >
                        ${cancelText}
                    </button>
                    <button
                        type="submit"
                        id="dialog-confirm-btn"
                        class="primary"
                    >
                        <p>${confirmText}</p>
                    </button>
                </menu>
            </form>
        </dialog>
    `
}
